"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistNotFound = void 0;
const wishlist_exception_1 = require("./wishlist-exception");
class WishlistNotFound extends wishlist_exception_1.WishlistException {
    constructor(wishlistId) {
        super(`Wishlist with id ${wishlistId} not found`);
        this.wishlistId = wishlistId;
        this.name = 'WishlistNotFound';
    }
}
exports.WishlistNotFound = WishlistNotFound;
